import styled from 'styled-components';

export const FlowFeedbackMessage = styled.p`
  margin-top: 20px;
`;

export const ThankYouContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 100%;
  height: 150px;
  text-align: center;
  margin: 0 auto;
`;



// WEBPACK FOOTER //
// ./src/screens/review-section2/thank-you/styles.tsx